import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "./slider-slide-zoomable.templates";

export default {
    title: "Components/Slider Slide Zoomable",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-slider-slide-zoomable",
    args: {
        isZoomed: "false",
    },
    argTypes: {
        isZoomed: {
            control: "boolean",
        },
    },
};

export const Default = {
    isZoomed: "false",
};
